import { ChangeDetectionStrategy, Component, inject } from '@angular/core'

import { FLX_MODAL_DATA, FlxModalModule } from '@flowx/angular-ui-toolkit'
import { FlxSpinnerModule } from '@flowx/designer/shared/components/spinner'

@Component({
  selector: 'flx-import-export-loading-modal',
  templateUrl: 'import-export-loading-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FlxModalModule, FlxSpinnerModule],
})
export class ImportExportLoadingModalComponent {
  data = inject(FLX_MODAL_DATA)
  type = this.data.type
}
